import axios from 'axios';
import {endpoint} from '../utils/utils';
import { getusertoken } from './login'

export const obtenerperiodo = async (usuario)=>{
    //await login();
    return axios.get(endpoint+'/proyeccion/periodo/'+usuario, getusertoken());	     
};

export const listaperiodos = async ()=>{
    //await login();
    return axios.get(endpoint+'/proyeccion/periodos', getusertoken());	     
};